<template>
  <div>
    <div class="bg-gray-800 rounded-sm p-x-sm-only-xs p-y-sm-only-xs p-x-lg p-y-m text-gray-50">
      <div class="flex flex-col">
        <h1 class="m-t-m m-b-xs font-heavy text-gray-50">Book Private Lesson</h1>
        <div class="flex gap-x-m m-t-xs align-items-start flex-col">
          <div class="text-gray-400 text-sm flex flex-col gap-y-xs">
            <div class="flex gap-x-xs align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 text-gray-50">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <span class="text-gray-50 text-18">{{ lessonLengthInMinutes }} minute lesson</span>
            </div>
            <div class="flex gap-x-xs align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-gray-50">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
              </svg>

              <span class="text-18 text-gray-50">{{ eventTimeRange }}</span>
            </div>
            <div v-if="event.location" class="flex gap-x-xs align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-gray-50">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
              </svg>

              <span class="text-18 text-gray-50 ">{{ event.location }}</span>
            </div>
            <div v-if="readableRosterList" class="flex gap-x-xs align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="w-6 h-6 text-gray-100" fill="currentColor"><path d="M336 64h-80a64 64 0 0 0-128 0H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM192 40a24 24 0 1 1-24 24 24 24 0 0 1 24-24zm144 418a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h42v36a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12v-36h42a6 6 0 0 1 6 6zm-99.2-106h-5a103.25 103.25 0 0 1-79.7 0h-5c-37.01 0-67.1 25.79-67.1 57.6v6.4a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-6.4c0-31.81-30.09-57.6-67.2-57.6zM192 336a64 64 0 1 0-64-64 64 64 0 0 0 64 64z"/>
              </svg>
              <span class="text-18 text-gray-50">{{ readableRosterList }}</span>
            </div>
          </div>
        </div>
        <h2 class="m-t-lg">Lesson Type</h2>
        <div v-for="billingPlan in availableBillingPlans" :key="billingPlan.id"
          class="border border-solid border-gray-200 rounded-xs p-m m-b-sm hover:border-blue-500 bg-gray-50 text-gray-600 cursor-pointer"
          :class="{ 'border-blue-700': selectedBillingPlan === billingPlan, 'border-2': selectedBillingPlan === billingPlan, 'bg-blue-50': selectedBillingPlan === billingPlan }">
          <div class="flex justify-space-between align-items-start" @click="selectedBillingPlan = billingPlan">
            <div>
              <div class="flex align-items-center gap-x-sm">
                <label class="font-semi m-y-none text-gray-600">{{ billingPlan.name }}</label>
              </div>
              <div class="text-gray-400 text-sm m-t-xs m-l-lg flex flex-col gap-y-xs">
                <div class="flex gap-x-xs align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 text-gray-600">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
                  </svg>
                  <span class="text-gray-600">{{ formatAsCurrency(lessonPrice(billingPlan)) }} per wrestler</span>
                </div>
                <div class="flex gap-x-xs align-items-center">
                  <wrestler-icon stroke-color="text-gray-700"></wrestler-icon>
                  <span class="text-gray-600">{{ billingPlan.max_wrestler_count }} wrestler limit</span>
                </div>
              </div>
            </div>
            <button
              @click.stop="selectedBillingPlan = billingPlan"
              class="btn btn-default flex align-items-center gap-x-sm"
              :class="selectedBillingPlan === billingPlan ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-50 hover:bg-gray-600'">
              <template v-if="selectedBillingPlan === billingPlan">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
                <span>Selected</span>
              </template>
              <template v-else>
                <span>Select</span>
              </template>
            </button>
          </div>
        </div>
      </div>
      <div v-if="selectedBillingPlan">
        <h2 class="m-t-lg">Select Wrestlers</h2>
        <div v-for="wrestler in possibleWrestlers" :key="wrestler.id"
          class="border border-solid border-gray-200 rounded-xs p-m m-b-sm hover:border-blue-500 bg-gray-50 text-gray-600 cursor-pointer"
          :class="{
            'border-red-700 bg-red-50': selectedWrestlers.includes(wrestler) && wrestlersWithoutPaymentMethod.some(w => w.id === wrestler.id),
            'border-blue-700 bg-blue-50': selectedWrestlers.includes(wrestler) && !wrestlersWithoutPaymentMethod.some(w => w.id === wrestler.id),
            'border-2': selectedWrestlers.includes(wrestler)
          }">
          <div class="flex justify-space-between align-items-start" @click="toggleWrestlerSelection(wrestler)">
            <div>
              <div class="flex align-items-center gap-x-sm flex-wrap">
                <label class="font-semi m-y-none text-gray-600">{{ wrestler.full_name }}</label>
                <!-- Payment Status -->
                <span v-if="wrestlersWithoutPaymentMethod.some(w => w.id === wrestler.id)" class="text-red-600 text-sm">
                  <i class="fa fa-exclamation-triangle"></i> No payment method
                </span>
                <span v-else-if="selectedWrestlers.includes(wrestler) && loading && !selectedBillables.some(b => b.wrestlerId === wrestler.id)" class="text-blue-600 text-sm">
                  <i class="fa fa-spinner fa-spin"></i> Checking payment methods...
                </span>
              </div>
              <div class="text-gray-400 text-sm m-t-xs m-l-lg flex flex-col gap-y-xs">
                <div class="flex gap-x-xs align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-6 h-6 text-gray-600" stroke="currentColor" fill="currentColor">
                    <path d="M448 64h-64.81C353.95 25.38 308.07 0 256 0s-97.95 25.38-127.19 64H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 48c61.86 0 112 50.14 112 112s-50.14 112-112 112-112-50.14-112-112S194.14 48 256 48zm208 400c0 8.84-7.16 16-16 16H64c-8.84 0-16-7.16-16-16V128c0-8.84 7.16-16 16-16h40.17C99.33 127.25 96 143.17 96 160c0 88.22 71.78 160 160 160s160-71.78 160-160c0-16.83-3.33-32.75-8.17-48H448c8.84 0 16 7.16 16 16v320zM256 240c17.67 0 32-14.33 32-32 0-8.06-3.25-15.22-8.18-20.85l23.36-70.09c6.66-20.08-23.63-30.2-30.38-10.12l-23.47 70.41C234.97 180.49 224 192.69 224 208c0 17.67 14.33 32 32 32z"/>
                  </svg>
                  <span class="text-gray-600">{{ wrestler.weight_class }}</span>
                </div>
                <div class="flex gap-x-xs align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-gray-600">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.871c1.355 0 2.697.056 4.024.166C17.155 8.51 18 9.473 18 10.608v2.513M15 8.25v-1.5m-6 1.5v-1.5m12 9.75-1.5.75a3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0 3.354 3.354 0 0 0-3 0 3.354 3.354 0 0 1-3 0L3 16.5m15-3.379a48.474 48.474 0 0 0-6-.371c-2.032 0-4.034.126-6 .371m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.169c0 .621-.504 1.125-1.125 1.125H4.125A1.125 1.125 0 0 1 3 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 0 1 6 13.12M12.265 3.11a.375.375 0 1 1-.53 0L12 2.845l.265.265Zm-3 0a.375.375 0 1 1-.53 0L9 2.845l.265.265Zm6 0a.375.375 0 1 1-.53 0L15 2.845l.265.265Z" />
                  </svg>
                  <span class="text-gray-600">{{ wrestler.age }} years old</span>
                </div>
              </div>
            </div>
            <button
              @click.stop="toggleWrestlerSelection(wrestler)"
              class="btn btn-default flex align-items-center gap-x-sm"
              :class="selectedWrestlers.includes(wrestler) ? 'bg-blue-600 text-white' : 'bg-gray-700 text-gray-50 hover:bg-gray-600'">
              <template v-if="selectedWrestlers.includes(wrestler)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
                <span>Selected</span>
              </template>
              <template v-else>
                <span>Select</span>
              </template>
            </button>
          </div>
          <!-- Show billables for this wrestler if it's selected -->
          <div v-if="selectedWrestlers.includes(wrestler) && selectedBillables.some(b => b.wrestlerId === wrestler.id)" class="text-gray-400 text-sm m-t-xs m-l-lg">
            <div class="flex gap-x-xs align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-gray-600">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
              </svg>

              <span class="text-gray-600">
                <span v-if="selectedBillables.filter(b => b.wrestlerId === wrestler.id).length === 1">
                  {{ selectedBillables.find(b => b.wrestlerId === wrestler.id).name }}
                </span>
                <span v-else-if="selectedBillables.filter(b => b.wrestlerId === wrestler.id).length === 2">
                  {{ selectedBillables.filter(b => b.wrestlerId === wrestler.id)[0].name }} or {{ selectedBillables.filter(b => b.wrestlerId === wrestler.id)[1].name }}
                </span>
                <span v-else>
                  <template v-for="(billable, index) in selectedBillables.filter(b => b.wrestlerId === wrestler.id)">
                    {{ billable.name }}{{ index < selectedBillables.filter(b => b.wrestlerId === wrestler.id).length - 2 ? ', ' : index === selectedBillables.filter(b => b.wrestlerId === wrestler.id).length - 2 ? ', or ' : '' }}
                  </template>
                </span>
                will be billed
              </span>
            </div>
          </div>

          <!-- Show guardian selection if wrestler has multiple guardians -->
          <div v-if="selectedWrestlers.includes(wrestler) && selectedBillables.filter(b => b.wrestlerId === wrestler.id).length > 1" class="m-t-sm p-l-lg">
            <div class="text-blue-600 text-sm m-b-xs">
              <i class="fa fa-user"></i> Select who will be billed:
            </div>
            <div class="flex flex-col gap-y-sm m-t-xs">
              <div v-for="guardian in selectedBillables.filter(b => b.wrestlerId === wrestler.id)"
                  :key="`guardian-option-${guardian.id}-${guardian.type}`"
                  class="flex align-items-center gap-x-sm p-sm rounded-xs hover:bg-gray-100 cursor-pointer border"
                  :class="{'border-blue-500': guardian.selected, 'bg-blue-50': guardian.selected, 'border-gray-200': !guardian.selected}"
                  @click="selectBillableForWrestler(guardian, wrestler)">
                <div class="flex-grow">
                  <div class="text-gray-700">
                    {{ guardian.name }}
                    <i v-if="guardian.hasPaymentMethod" class="fa fa-check-circle text-blue-600" title="Has payment method"></i>
                    <i v-else class="fa fa-exclamation-circle text-red-600" title="No payment method"></i>
                  </div>
                  <div v-if="guardian.hasPaymentMethod" class="text-xs text-green-500">Has payment method on file</div>
                  <div v-else class="text-xs text-red-500">No payment method on file</div>
                </div>
                <button class="btn btn-sm" :class="guardian.selected ? 'btn-primary' : 'btn-outline-primary'">
                  <i class="fa fa-check"></i> {{ guardian.selected ? 'Selected' : 'Select' }}
                </button>
              </div>
            </div>
          </div>

          <!-- Show warning if wrestler is selected but has no billables -->
          <div v-else-if="selectedWrestlers.includes(wrestler) && wrestlersWithoutPaymentMethod.some(w => w.id === wrestler.id)" class="m-t-sm p-l-lg">
            <div class="text-red-600 text-sm">
              <i class="fa fa-exclamation-triangle"></i> {{ wrestler.full_name }}'s guardian must have a card on file to book this lesson
            </div>
          </div>

          <!-- Loading state while checking for guardians -->
          <div v-else-if="selectedWrestlers.includes(wrestler) && loading && !selectedBillables.some(b => b.wrestlerId === wrestler.id)" class="m-t-sm p-l-lg">
            <div class="text-blue-600 text-sm">
              <i class="fa fa-spinner fa-spin"></i> Checking for payment methods...
            </div>
          </div>
        </div>
        <div v-for="wrestler in wrestlersNotEligible" :key="wrestler.id" class="alert alert-warning m-t-none m-b-sm">
          <i class="fa fa-exclamation-triangle"></i> {{ wrestler.full_name }} is not eligible for this lesson. Only wrestlers on the {{ readableRosterList }} roster can attend.
        </div>
      </div>
      <div v-if="overCapacity && selectedBillingPlan">
        <p class="text-red-800 bg-red-50 p-sm rounded-xs">You have selected too many wrestlers. There {{ capacityLeftInBillingPlan === 1 ? 'is' : 'are' }} only {{ capacityLeftInBillingPlan }} {{ capacityLeftInBillingPlan === 1 ? 'spot' : 'spots' }} left.</p>
      </div>
      <div v-if="selectedBillingPlan && hasSelectedWrestler && !overCapacity">
        <h2 class="m-t-lg">Review</h2>
        <!-- Per-Guardian Payment Sections This is where teh issue si, we should only show the guardian if they are selected in the multiple guardian case. -->
        <div v-for="(guardianKey, index) in Object.keys(wrestlersByGuardian)" :key="guardianKey" class="border rounded-xs p-m m-b-lg" :class="{'border-red-200 bg-red-50': !guardianHasPaymentMethod(guardianKey), 'border-gray-200 bg-gray-50': guardianHasPaymentMethod(guardianKey)}">
          <h3 class="m-t-none m-b-sm" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey), 'text-gray-600': guardianHasPaymentMethod(guardianKey)}">Payment for {{ wrestlersByGuardian[guardianKey].guardian.name }}</h3>

          <div class="m-b-md">
            <p class="text-gray-600 m-b-sm" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey)}">
              <div class="flex gap-x-xs text-gray-600 align-items-center">
                  <wrestler-icon stroke-color="text-gray-700"></wrestler-icon>
                  <span v-for="(wrestler, wIndex) in wrestlersByGuardian[guardianKey].wrestlers" :key="wrestler.id">
                    {{ wrestler.full_name }}{{ wIndex < wrestlersByGuardian[guardianKey].wrestlers.length - 1 ? ', ' : '' }}
                  </span>
              </div>
            </p>
          </div>

          <label class="text-18" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey), 'text-gray-600': guardianHasPaymentMethod(guardianKey)}">Cart</label>
          <div class="flex flex-col gap-y-sm m-t-xs align-items-start w-full max-w-xl" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey), 'text-gray-600': guardianHasPaymentMethod(guardianKey)}">
            <div class="flex gap-x-sm align-items-center justify-space-between w-full">
              <label class="">Lesson</label>
              <div class="">{{ formatAsCurrency(subtotalForGuardian(guardianKey)) }}</div>
            </div>
            <div class="flex gap-x-sm align-items-center justify-space-between w-full">
              <label class="">WrestlingIQ Fee</label>
              <div class="">{{ formatAsCurrency(wiqFeeForGuardian(guardianKey)) }}</div>
            </div>
            <div class="flex gap-x-sm align-items-center justify-space-between w-full">
              <label class="font-semi">Total</label>
              <div class="">{{ formatAsCurrency(totalForGuardian(guardianKey)) }}</div>
            </div>
          </div>

          <label class="text-18 m-t-md" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey), 'text-gray-600': guardianHasPaymentMethod(guardianKey)}">Payment</label>
          <div class="flex gap-x-m m-t-xs align-items-start" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey), 'text-gray-600': guardianHasPaymentMethod(guardianKey)}">
            <div>
              <label class="m-b-none">Autocharge card on file</label>
              <p class="m-t-none text-gray-600 text-12 max-w-xl" :class="{'text-red-600': !guardianHasPaymentMethod(guardianKey), 'text-gray-600': guardianHasPaymentMethod(guardianKey)}">
                Your card will be auto-charged after the lesson is complete. Cancellations may be auto-charged if the lesson is cancelled too close to the scheduled time; please ask your coach about team cancellation policies.
              </p>

              <!-- Show payment method for this guardian -->
              <div v-if="guardianBillingProfiles[guardianKey] && guardianBillingProfiles[guardianKey].default_payment_method_reusable">
                <label class="m-t-sm">Card on file</label>
                <div class="flex align-items-center gap-x-sm">
                  <div v-html="getCardLogo(guardianBillingProfiles[guardianKey])"></div>
                  <div class="font-heavy">* * * * {{
                      guardianBillingProfiles[guardianKey].default_payment_method_last4
                    }}
                  </div>
                  <div class="">
                    {{guardianBillingProfiles[guardianKey].default_payment_method_exp_month }} / {{ guardianBillingProfiles[guardianKey].default_payment_method_exp_year }}
                  </div>
                </div>
                <div @click.prevent="updateGuardianCard(wrestlersByGuardian[guardianKey].guardian)" class="btn btn-default btn-sm m-t-sm">
                    <i class="fa fa-pencil"></i> Change card on file
                </div>
              </div>
              <div v-else>
                <p class="m-y-none text-red-600">
                  <i class="fa fa-exclamation-triangle"></i> No card on file for {{ wrestlersByGuardian[guardianKey].guardian.name }} that is authorized for auto-charging. Please add one below, making sure to leave the 'save billing & card info for future checkout' box checked.
                </p>
                <button @click.prevent="loadGuardianBillingProfile(wrestlersByGuardian[guardianKey].guardian)" class="btn btn-default w-full flex justify-center gap-x-xxxs m-t-xxs align-items-baseline m-t-sm">
                  <i class="fa fa-plus m-r-xs"></i> <span>Add Card</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <h2 class="m-t-lg">Confirm</h2>
        <div class="flex flex-col gap-y-xs w-full">
            <ladda-button
              :loading="loading"
              :disabled="loading || !selectedBillingPlan || !allGuardiansWithPaymentMethods || !hasSelectedGuardians"
              @lbClicked="confirmBooking"
              class="btn btn-primary btn-lg font-semi"
            >
              Confirm Booking
            </ladda-button>
            <span v-if="!selectedBillingPlan" class="alert alert-danger"><i class="fa fa-exclamation-triangle"></i> Select a lesson type to book</span>
            <span v-if="!hasSelectedGuardians" class="alert alert-danger"><i class="fa fa-exclamation-triangle"></i> Please select guardians for all wrestlers</span>
            <span v-if="hasSelectedGuardians && !allGuardiansWithPaymentMethods" class="alert alert-danger">
              Selected guardians must have payment methods added before confirming the lesson
            </span>
            <span v-if="error" class="alert alert-danger"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</span>
          </div>
      </div>
    </div>
    <div id="card-modal" class="modal fade hidden-print" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Update card on file <span v-if="currentGuardian">{{ currentGuardian.name }}</span></h4>
          </div>
          <div class="modal-body" v-if="this.recipientBillingProfile && renderCardForm" style="margin-bottom: -8px;">
            <update-cc
                :billing-profile="this.recipientBillingProfile"
                :billing-partner="this.recipientBillingProfile.billing_update_meta.billing_partner"
                :billing-key="this.recipientBillingProfile.billing_update_meta.billing_partner_key"
                :billing-acct-id="this.recipientBillingProfile.billing_update_meta.billing_partner_id"
                :billing-intent-secret="this.recipientBillingProfile.billing_update_meta.intent.client_secret"
                :team-name="this.recipientBillingProfile.billing_update_meta.team.name"
                :team-currency="this.teamCurrency"
                :should-redirect="false"
                :force-reusable-card="true"
                force-reusable-card-reason="Booking a private lesson requires a card on file prior to scheduling."
                @card-updated="cardUpdated"
                :use-google-autocomplete="true"
            >
            </update-cc>
            <div class="m-t-sm">
              <button type="button" class="btn btn-default btn-block" @click.prevent="toggleCardModal">Cancel</button>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
  </div>
</template>

<script>
import { cardLogoMix } from '../../shared/card_logo_mix';
import UpdateCc from './update_cc.vue';
import { errorableMix } from './mixins/errorable_mix';
import { currencyMix } from '../../shared/currency_mix';
import LaddaButton from '../../shared/ladda_button.vue';
import { formattingMixin } from './mixins/formatting_mix';
import Spinner from './spinner.vue';
import WrestlerIcon from '../../shared/wrestler-icon.vue';
import { appEmbedMix } from './mixins/app_embed_mix';
import qs from 'qs';

export default {
  name: 'private-lesson-booking-form',
  mixins: [cardLogoMix, errorableMix, formattingMixin, currencyMix, appEmbedMix],
  components: {
    LaddaButton,
    Spinner,
    UpdateCc,
    WrestlerIcon
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    teamCurrency: {
      type: String,
      default: 'usd',
    },
    percentFee: {
      type: Number,
      default: 0,
    },
    bookedById: {
      type: Number,
      required: true,
    },
    bookedByType: {
      type: String,
      required: true,
    },
    availableBillingPlans: {
      type: Array,
      required: true,
    },
    lessonLengthInMinutes: {
      type: Number,
      required: true,
    },
    privateLessonId: {
      type: Number,
      required: true,
    },
    eligibleWrestlers: {
      type: Array,
      required: true,
    },
    ineligibleWrestlers: {
      type: Array,
      required: true,
    },
    prefilledWrestlers: {
      type: Array,
      required: true,
    },
    bookingsAlreadyConfirmed: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      recipientBillingProfile: null,
      renderCardForm: false,
      selectedBillingPlan: null,
      selectedWrestlers: [],
      recipientBillingProfiles: [],
      // All possible billables for the selected wrestlers
      selectedBillables: [],
      wrestlersWithoutPaymentMethod: [],
      guardianBillingProfiles: {},
      currentGuardian: null,
      error: false,
      errorMessage: '',
    }
  },
  created() {
    this.initializeComponent();
  },
  computed: {
    hasSelectedGuardians() {
      return this.selectedWrestlers.every(
        wrestler => this.selectedBillables.some(
          billable => billable.wrestlerId === wrestler.id && billable.selected
        )
      );
    },
    eventRosters() {
      return _.map(this.event.roster_events, 'roster');
    },
    readableRosterList() {
      if (!this.eventRosters.length) return null;
      const rosters = _.map(this.eventRosters, 'name');
      if (rosters.length === 1) return rosters[0];
      if (rosters.length === 2) return `${rosters[0]} or ${rosters[1]}`;
      return rosters.slice(0, -1).join(', ') + ', or ' + rosters[rosters.length - 1];
    },
    // Wrestler Selection Computed Properties
    possibleWrestlers() {
      return this.prefilledWrestlers.length > 0 ? this.prefilledWrestlers : this.eligibleWrestlers;
    },
    // This should be ineligible wrestlers, minus prefilled wrestlers
    wrestlersNotEligible() {
      return _.filter(this.ineligibleWrestlers, wrestler => !this.prefilledWrestlers.includes(wrestler));
    },
    hasSelectedWrestler() {
      return this.selectedWrestlers.length > 0;
    },

    // Capacity & Booking Computed Properties
    capacityLeftInBillingPlan() {
      if (!this.selectedBillingPlan) return 0;
      return this.selectedBillingPlan.max_wrestler_count - this.bookingsAlreadyConfirmed;
    },
    overCapacity() {
      return this.selectedWrestlers.length > this.capacityLeftInBillingPlan;
    },

    // Display Computed Properties
    eventTimeRange() {
      return `${moment(this.event.start_at).format('ddd MMMM Do YYYY, h:mm a')} - ${moment(this.event.end_at).format('h:mm a')}`;
    },

    // Payment Computed Properties
    canChargeCardOnFile() {
      return this.recipientBillingProfile && this.recipientBillingProfile.default_payment_method_reusable;
    },

    // Pricing Computed Properties
    lessonSubtotal() {
      return this.lessonPrice(this.selectedBillingPlan) * this.selectedWrestlers.length;
    },
    lessonWrestlingIQFee() {
      return this.lessonSubtotal * this.percentFee;
    },
    lessonTotal() {
      return this.lessonSubtotal + this.lessonWrestlingIQFee;
    },

    // Guardian-related Computed Properties
    uniqueGuardians() {
      const guardians = [];
      const guardianKeys = new Set();

      for (const billable of this.selectedBillables) {
        const key = this.getGuardianKey(billable);
        if (!guardianKeys.has(key)) {
          guardianKeys.add(key);
          guardians.push(billable);
        }
      }

      return guardians;
    },
    wrestlersByGuardian() {
      const result = {};

      for (const billable of this.selectedBillables) {
        // We only want to show the guardian if they are selected in the multiple guardian case. Our code auto selects the first guardian for single guardian cases.
        if (billable.selected) {
          const key = this.getGuardianKey(billable);
          if (!result[key]) {
            result[key] = {
              guardian: billable,
              wrestlers: []
            };
          }
          const wrestler = this.selectedWrestlers.find(w => w.id === billable.wrestlerId);
          if (wrestler) {
            result[key].wrestlers.push(wrestler);
          }
        }
      }

      return result;
    },
    allWrestlersHaveGuardians() {
      return this.selectedWrestlers.every(wrestler =>
        this.selectedBillables.some(billable => billable.wrestlerId === wrestler.id) ||
        this.getWrestlerGuardianOptions(wrestler).length > 0
      );
    },
    hasWrestlersWithoutBillables() {
      return this.selectedWrestlers.some(wrestler =>
        !this.selectedBillables.some(billable => billable.wrestlerId === wrestler.id)
      );
    },
    allGuardiansWithPaymentMethods() {
      if (this.selectedBillables.length === 0) return false;

      // Check if all selected guardians have payment methods
      for (const guardian of this.selectedBillables) {
        if (!guardian.selected) continue;
        const guardianKey = this.getGuardianKey(guardian);
        const billingProfile = this.guardianBillingProfiles[guardianKey];

        if (!billingProfile || !billingProfile.default_payment_method_reusable) {
          return false;
        }
      }

      return true;
    },
  },
  methods: {
    // Initialization
    initializeComponent() {
      // Preselect wrestlers if provided
      for (const wrestler of this.prefilledWrestlers) {
        this.toggleWrestlerSelection(wrestler);
      }

      // Auto-select billing plan if only one is available
      if (this.availableBillingPlans.length === 1) {
        this.selectedBillingPlan = this.availableBillingPlans[0];
      }
    },

    // Helper Methods
    getGuardianKey(guardian) {
      return `${guardian.id}-${guardian.type}`;
    },
    guardianHasPaymentMethod(guardianKey) {
      return this.guardianBillingProfiles[guardianKey] &&
        this.guardianBillingProfiles[guardianKey].default_payment_method_reusable;
    },

    // Pricing Methods
    lessonPrice(billingPlan) {
      if (!billingPlan) return 0;
      return billingPlan.amount * (this.lessonLengthInMinutes / 60);
    },
    subtotalForGuardian(guardianKey) {
      const group = this.wrestlersByGuardian[guardianKey];
      if (!group) return 0;

      return this.lessonPrice(this.selectedBillingPlan) * group.wrestlers.length;
    },
    wiqFeeForGuardian(guardianKey) {
      return this.subtotalForGuardian(guardianKey) * this.percentFee;
    },
    totalForGuardian(guardianKey) {
      return this.subtotalForGuardian(guardianKey) + this.wiqFeeForGuardian(guardianKey);
    },

    // Card Modal Methods
    cardUpdated() {
      if (this.currentGuardian) {
        this.loadGuardianBillingProfile(this.currentGuardian);
      }
      this.toggleCardModal();
    },
    toggleCardModal() {
      this.renderCardForm = !this.renderCardForm;
      $('#card-modal').modal('toggle');

      // Reset currentGuardian when the modal is closed
      if (!this.renderCardForm) {
        this.currentGuardian = null;
      }
    },

    // Wrestler Selection Methods
    toggleWrestlerSelection(wrestler) {
      const index = this.selectedWrestlers.findIndex(w => w.id === wrestler.id);

      if (index > -1) {
        this.removeWrestler(wrestler, index);
      } else {
        this.addWrestler(wrestler);
      }
    },
    removeWrestler(wrestler, index) {
      // Remove wrestler from selected list
      this.selectedWrestlers.splice(index, 1);

      // Remove wrestler from no-payment list if present
      const noPaymentIndex = this.wrestlersWithoutPaymentMethod.findIndex(w => w.id === wrestler.id);
      if (noPaymentIndex > -1) {
        this.wrestlersWithoutPaymentMethod.splice(noPaymentIndex, 1);
      }

      // Remove associated billables
      this.selectedBillables = this.selectedBillables.filter(b => b.wrestlerId !== wrestler.id);
    },
    addWrestler(wrestler) {
      // Add wrestler to selected list
      this.selectedWrestlers.push(wrestler);

      // Check if wrestler has guardians that can be billables
      if (wrestler.guardians && wrestler.guardians.length > 0) {
        this.findBillablesFromGuardians(wrestler);
      } else {
        // If no guardians, add to the list of wrestlers without payment methods
        this.wrestlersWithoutPaymentMethod.push(wrestler);
      }
    },

    // Guardian and Payment Method Methods
    findBillablesFromGuardians(wrestler) {
      this.loading = true;

      let guardiansToCheck = wrestler.guardians || [];
      if (this.bookedByType === 'ParentProfile') {
        guardiansToCheck = _.filter(guardiansToCheck, guardian => guardian.id === this.bookedById && guardian.type === 'ParentProfile');
      }
      const checkPromises = guardiansToCheck.map(guardian =>
        this.checkGuardianPaymentMethod(guardian, wrestler)
      );

      Promise.all(checkPromises)
        .then(results => {
          // Check if any guardian has a payment method
          const hasAnyPaymentMethod = results.some(result => result === true);

          // If there is only one guardian, select it
          if (guardiansToCheck.length === 1) {
            this.selectBillableForWrestler(guardiansToCheck[0], wrestler);
          }

          // If no guardian has a payment method, add wrestler to the warning list
          if (!hasAnyPaymentMethod) {
            this.wrestlersWithoutPaymentMethod.push(wrestler);
          }
        })
        .catch(error => {
          console.error("Error checking guardian payment methods:", error);
          this.wrestlersWithoutPaymentMethod.push(wrestler);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkGuardianPaymentMethod(guardian, wrestler) {
      return new Promise((resolve, reject) => {
        if (!guardian.type) {
          console.error("Guardian missing required type:", guardian);
          reject(new Error("Guardian type is required"));
          return;
        }

        const url = this.$apiService.profileBillingProfileUrl(guardian.id, guardian.type);

        axios.get(url)
          .then(response => {
            const hasPaymentMethod = response.data && response.data.default_payment_method_reusable;

            // Store billing profile regardless of payment method status
            this.$set(this.guardianBillingProfiles, `${guardian.id}-${guardian.type}`, response.data);

            // Add guardian to potential billables
            this.addGuardianToBillables(guardian, wrestler, hasPaymentMethod);

            resolve(hasPaymentMethod);
          })
          .catch(error => {
            console.error("Error checking guardian payment method:", error);

            // Still add the guardian to billables but mark as having no payment method
            this.addGuardianToBillables(guardian, wrestler, false);

            resolve(false);
          });
      });
    },
    addGuardianToBillables(guardian, wrestler, hasPaymentMethod) {
      if (!guardian.type) {
        console.error("Cannot add guardian without type to billables:", guardian);
        return;
      }

      const guardianName = guardian.name || `${guardian.first_name} ${guardian.last_name}`;

      this.selectedBillables.push({
        id: guardian.id,
        type: guardian.type,
        name: guardianName,
        wrestlerId: wrestler.id,
        hasPaymentMethod: hasPaymentMethod,
        selected: false
      });
    },

    // UI Interaction Methods
    getWrestlerGuardianOptions(wrestler) {
      const foundWrestler = this.selectedWrestlers.find(w => w.id === wrestler.id);
      return foundWrestler ? (foundWrestler.guardianOptions || []) : [];
    },
    selectBillableForWrestler(guardian, wrestler) {
      // Find all billables for this wrestler
      const wrestlerBillables = this.selectedBillables.filter(b => b.wrestlerId === wrestler.id);

      // Update selection status
      wrestlerBillables.forEach(billable => {
        // Using Vue.set to ensure reactivity
        this.$set(billable, 'selected', billable.id === guardian.id && billable.type === guardian.type);
      });
    },

    // Payment Methods
    loadGuardianBillingProfile(guardian) {
      this.loading = true;
      this.currentGuardian = guardian;

      if (!guardian.type) {
        console.error("Guardian missing required type:", guardian);
        this.errorMessage = 'Guardian type is required. Please contact support.';
        this.error = true;
        this.loading = false;
        return;
      }

      const url = this.$apiService.profileBillingProfileUrl(guardian.id, guardian.type);
      axios.get(url)
        .then((response) => {
          // Store the billing profile
          this.$set(this.guardianBillingProfiles, `${guardian.id}-${guardian.type}`, response.data);

          if (response.data && response.data.default_payment_method_reusable) {
            this.$notificationManager.$emit('show-toast', `${guardian.name} has a valid payment method on file`, true);
            // Update any existing billables for this guardian to reflect they have a payment method
            this.selectedBillables.forEach((billable, index) => {
              if (billable.id === guardian.id && billable.type === guardian.type) {
                this.$set(this.selectedBillables, index, {
                  ...billable,
                  hasPaymentMethod: true
                });
              }
            });
            // Remove wrestler from no-payment list if present
            const noPaymentIndex = this.wrestlersWithoutPaymentMethod.findIndex(w => w.id === guardian.wrestlerId);
            if (noPaymentIndex > -1) {
              this.wrestlersWithoutPaymentMethod.splice(noPaymentIndex, 1);
            }
          } else {
            // Show the card modal to add a card
            this.recipientBillingProfile = response.data;
            this.toggleCardModal();
          }
        })
        .catch((error) => {
          console.error(error);
          this.errorMessage = 'Something went wrong loading billing profile. Try again or email support.';
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateGuardianCard(guardian) {
      this.currentGuardian = guardian;
      this.recipientBillingProfile = this.guardianBillingProfiles[`${guardian.id}-${guardian.type}`];
      this.toggleCardModal();
    },
    getCardLogo(billingProfile) {
      if (!billingProfile) return '';

      switch (billingProfile.default_payment_method_brand) {
        case 'visa':
          return this.visaLogo;
        case 'mastercard':
          return this.mastercardLogo;
        case 'amex':
        case 'american_express':
          return this.amexLogo;
        case 'discover':
          return this.discoverLogo;
        default:
          return `<div>${billingProfile.default_payment_method_brand}</div>`;
      }
    },

    // Booking Methods
    confirmBooking() {
      if (!this.validateBookingForm()) return;

      this.loading = true;
      this.error = false;

      // Track successes and failures
      const results = {
        successes: [],
        failures: []
      };

      // Process each wrestler booking sequentially to avoid race conditions
      const processBookings = async () => {
        for (const wrestler of this.selectedWrestlers) {
          try {
            const response = await this.createEventBookingForWrestler(wrestler);
            results.successes.push({
              wrestlerId: wrestler.id,
              wrestlerName: wrestler.full_name,
              bookingId: response.data.id,
              response: response.data
            });
          } catch (error) {
            results.failures.push({
              wrestlerId: wrestler.id,
              wrestlerName: wrestler.full_name,
              error: error
            });
          }
        }

        // After all processing is complete, handle results
        this.handleBookingResults(results);
      };

      // Start the booking process
      processBookings();
    },
    validateBookingForm() {
      // Check if any wrestler doesn't have a selected guardian
      for (const wrestler of this.selectedWrestlers) {
        if (!this.selectedBillables.some(b => b.wrestlerId === wrestler.id)) {
          this.errorMessage = `Please select a guardian for ${wrestler.full_name}.`;
          this.error = true;
          return false;
        }
      }

      // Check if we have any guardians selected
      if (Object.keys(this.wrestlersByGuardian).length === 0) {
        this.errorMessage = "No guardians selected. Please select at least one guardian.";
        this.error = true;
        return false;
      }

      // Check for guardians without payment methods
      const guardiansWithoutPayment = this.getGuardiansWithoutPayment();
      if (guardiansWithoutPayment.length > 0) {
        const guardianNames = guardiansWithoutPayment.map(g => g.name).join(", ");
        this.errorMessage = `The following selected guardians need payment methods added: ${guardianNames}. Click on "Add Card" button to add payment information.`;
        this.error = true;
        return false;
      }

      return true;
    },
    getGuardiansWithoutPayment() {
      const guardiansWithoutPayment = [];

      for (const guardian of this.selectedBillables) {
        if (!guardian.selected) continue;
        const guardianKey = this.getGuardianKey(guardian);
        const billingProfile = this.guardianBillingProfiles[guardianKey];

        if (!billingProfile || !billingProfile.default_payment_method_reusable) {
          guardiansWithoutPayment.push(guardian);
        }
      }

      return guardiansWithoutPayment;
    },
    createEventBookingForWrestler(wrestler) {
      // Find the selected billable for this wrestler
      const selectedBillable = this.selectedBillables.find(b => b.wrestlerId === wrestler.id && b.selected);
      const guardianKey = this.getGuardianKey(selectedBillable);
      const billingProfile = this.guardianBillingProfiles[guardianKey];

      if (!selectedBillable) {
        console.error('No selected billable found for wrestler:', wrestler);
        return Promise.reject(`Error: No selected guardian found for ${wrestler.full_name}`);
      }

      const params = this.buildBookingParams(wrestler, billingProfile);
      const url = this.$apiService.eventBookingsUrl();

      // Return the promise instead of handling it here
      return axios.post(url, params);
    },
    buildBookingParams(wrestler, billingProfile) {
      return {
        event_booking: {
          billing_profile_id: billingProfile.id,
          profile_id: wrestler.id,
          profile_type: "WrestlerProfile",
          event_id: this.event.id,
          booked_by_id: this.bookedById,
          booked_by_type: this.bookedByType,
          private_lesson_id: this.privateLessonId,
          billing_plan_id: this.selectedBillingPlan.id,
          status: "confirmed",
        }
      };
    },
    handleAllBookingsSuccess(bookingIds) {
      if (this.forAppEmbed) {
        this.askAppToPop({
          name: 'event_booking_created',
          data: {
            event_booking_ids: bookingIds,
            event_id: this.event.id,
            private_lesson_id: this.privateLessonId,
            pop_to_root: true,
            alert: {
              type: 'success',
              message: 'Private lesson booked! View lessons by tapping the whistle icon on the calendar.'
            }
          }
        });
      } else {
        // Join all booking IDs with commas
        const bookingIdParams = qs.stringify({ event_booking_ids: bookingIds }, { arrayFormat: 'brackets' });
        window.location.href = `/events/${this.event.id}?booking_complete=true&${bookingIdParams}`;
      }
    },
    handleAllBookingsError(errors) {
      console.error("Some bookings failed:", errors);

      // Check if errors is an array of errors or a single error
      if (Array.isArray(errors)) {
        this.errorMessage = "Some bookings failed. Please try again or contact support.";
      } else {
        this.errorMessage = this.parseErrorResponse(errors);
      }

      this.error = true;
      this.loading = false;
    },
    handleBookingResults(results) {
      this.loading = false;

      // If we have any successes
      if (results.successes.length > 0) {
        const bookingIds = results.successes.map(success => success.bookingId);

        // If we have some failures
        if (results.failures.length > 0) {
          const failedNames = results.failures.map(f => f.wrestlerName).join(', ');
          this.$notificationManager.$emit('show-toast',
            `Warning: Bookings for ${failedNames} failed. Other wrestlers were successfully booked.`,
            false
          );
        }

        // Redirect with successful bookings
        this.handleAllBookingsSuccess(bookingIds);
      } else if (results.failures.length > 0) {
        // All bookings failed
        const errors = results.failures.map(f => f.error);
        this.handleAllBookingsError(errors);
      }
    },
  },
};
</script>
